import React from 'react';

import FadeIn from './animations/FadeIn';
import Button from './Button';

export function CTABanner({
  containerClassName = '',
  title = 'Form a better life now.',
  description = '',
  button_url = '/register',
  button_text = 'Get your 7 day unrestricted trial',
  buttonColor = 'cloud',
  terms = 'No credit card needed.',
  bgImage = '/website/logo-v3/graphics/4-5.svg',
  wide = false,
}) {
  return (
    <div
      className={`bg-gold justify-center bg-cover bg-center ${containerClassName}`}
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="max-w-[1680px] relative px-5 xl:px-10 mx-auto">
        <div className="py-16 px-2 xl:px-16 xl:py-24">
          <FadeIn>
            <div className={`${wide ? 'w-[500px]' : 'w-[350px]'} max-w-full`}>
              <h2 className="!text-4xl !font-light">{title}</h2>
              {description ? (
                <p className="hidden lg:block">{description}</p>
              ) : null}
              <Button solid color={buttonColor} lg href={button_url}>
                {button_text}
              </Button>
              <div className="text-xs my-3 opacity-75">{terms}</div>
            </div>
          </FadeIn>
        </div>
      </div>
    </div>
  );
}
